module.exports = __webpack_public_path__ + "static/media/Level3english.9361fcd9.svg";